<template>
  <div class="mt-5 shadow-card white-bg rounded p-5">
    <h2>Create Referral</h2>
    <div class="form-group" v-if="vendor.locations.length > 1">
      <label for class="font-weight-bold">Location</label>
      <select class="form-control" v-model="order.location">
        <option value>Select a Location</option>
        <option :value="l.id" v-for="l in sortedlocations" :key="l.id">
          {{ getFormattedLocation(l) }}
        </option>
      </select>
    </div>
    <div class="form-group">
      <label class="font-weight-bold">Service Type</label>
      <select
        class="form-control"
        v-model="order.service"
        @change="order.subService = ''"
      >
        <option value>Select a Service</option>
        <option :value="s" v-for="s in vendorServices" :key="s.id">
          {{ s.name }}
        </option>
      </select>
    </div>
    <div
      class="form-group"
      v-if="order.service && (order.service.sub || []).length"
    >
      <label class="font-weight-bold">Sub-Service Type</label>
      <select class="form-control" v-model="order.subService">
        <option value="">Select a Sub-Service</option>
        <option :value="s" v-for="s in order.service.sub" :key="s.id">
          {{ s.name }}
        </option>
      </select>
    </div>
    <div
      class="form-group"
      v-if="
        order.service && order.subService && order.subService.options.length > 0
      "
    >
      <label class="font-weight-bold">Service Options</label>
      <br />
      <div
        class="custom-control custom-switch custom-control-inline"
        v-for="o in order.subService.options"
        :key="o"
      >
        <input
          type="checkbox"
          class="custom-control-input"
          :id="order.subService.id + `-${o}`"
          :value="o"
          v-model="order.options"
        />
        <label
          class="custom-control-label"
          :for="order.subService.id + `-${o}`"
          >{{ o }}</label
        >
      </div>
    </div>
    <div class="form-group">
      <label class="font-weight-bold">Referral Details</label>
      <textarea
        class="form-control"
        rows="1"
        placeholder="Order Details"
        v-model="order.details"
        v-autosize
      ></textarea>
    </div>
    <div
      class="form-group"
      v-if="
        !vendor.prevent_documents &&
        (!vendor.prevent_public_referrals || loggedInUser.isVendor)
      "
    >
      <label class="font-weight-bold">Attach Case Document</label>
      <div class="custom-file" v-if="orders.attachment.id == null">
        <input
          type="file"
          class="custom-file-input"
          @change="uploadAttachment"
        />
        <label class="custom-file-label">Attach file</label>
      </div>
      <div class="py-2" v-if="orders.attachment.file">
        <div class="badge badge-primary h2">
          <i class="fas fa-check mr-2" v-if="orders.attachment.id"></i>
          <i
            class="fas fa-spinner fa-spin mr-2"
            v-if="orders.attachment.id == null"
          ></i>
          {{ orders.attachment.file }}
        </div>
      </div>
      <div
        class="my-3"
        v-if="orders.attachment.progress > 0 && orders.attachment.id == null"
      >
        <div class="progress">
          <div
            class="progress-bar"
            role="progressbar"
            :style="`width: ${orders.attachment.progress}%`"
          >
            {{ progressPercent }}
          </div>
        </div>
      </div>
    </div>
    <div class="form-group">
      <div class="custom-control custom-switch">
        <input
          type="checkbox"
          class="custom-control-input"
          id="customSwitch1"
          v-model="order.contactNow"
        />
        <label class="custom-control-label cursor-pointer" for="customSwitch1"
          >Have Vendor Call Me</label
        >
      </div>
    </div>
    <div class="row">
      <div class="col btn-container">
        <button class="btn mt-3 btn-success btn-lg" @click="submitOrder()">
          <span v-if="!orders.isLoading.submitting">
            <icon type="check" class="mr-2" />Initiate Referral
          </span>
          <span
            class="spinner-border spinner-border-sm"
            v-if="orders.isLoading.submitting"
            role="status"
            aria-hidden="true"
          ></span>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import Swal from "sweetalert2";
import Auth from "../../auth";
import { formatLocation } from "@/utils/helpers";

export default {
  name: "Create",
  props: {
    vendor: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState(["services", "user", "orders"]),
    progressPercent: function () {
      if (typeof this.orders.attachment.progress == Number) {
        if (this.orders.attachment.progress < 100) {
          return this.orders.attachment.progress + "%";
        } else {
          return "Processing.... ";
        }
      }
      return this.orders.attachment.progress;
    },
    vendorServices: function () {
      if (
        this.vendor &&
        this.vendor.services &&
        this.services &&
        this.services.data
      ) {
        const servicesIds = [];
        this.vendor.services.forEach((service) => {
          servicesIds.push(service.id);
        });
        const services = this.services.data.filter((service) =>
          servicesIds.includes(service.id)
        );
        return services;
      }
      return [];
    },
    loggedInUser: function () {
      return Auth.user.get();
    },
  },
  data() {
    return {
      order: {
        location: "",
        service: "",
        subService: "",
        details: "",
        attachment: null,
        contactNow: false,
        options: [],
      },
      sortedlocations: [],
    };
  },
  created: function () {
    if (
      this.vendor &&
      (this.vendor.prevent_referrals ||
        (this.vendor.prevent_public_referrals &&
          !this.loggedInUser.isVendor &&
          !this.loggedInUser.isAdmin))
    ) {
      Swal.fire({
        type: "info",
        title: "",
        text: `You can't connect to ${this.vendor.name} per his settings.`,
      });
      this.$router.replace({ path: "/" });
    }
    this.getServices();
    this.sortVendorLocations(this.vendor.locations);
    if (
      this.vendor &&
      this.vendor.locations &&
      this.vendor.locations.length == 1
    ) {
      this.order.location = this.vendor.locations[0].id;
    }
    this.$store.commit("orders/RESET_ATTACHMENT");
  },
  methods: {
    submitOrder: function () {
      if (!this.order.location) {
        return Swal.fire({
          type: "error",
          title: "Validation Error",
          text: "Vendor Location is required",
        });
      } else if (!this.order.service) {
        return Swal.fire({
          type: "error",
          title: "Validation Error",
          text: "Service Type is required",
        });
      }
      if (this.orders.attachment.id != null) {
        this.order.attachment = this.orders.attachment.id;
        const vm = this;
        const swalWithBootstrapButtons = Swal.mixin({
          customClass: {
            confirmButton: "btn btn-success ml-4",
            cancelButton: "btn btn-danger",
          },
          buttonsStyling: false,
        });

        swalWithBootstrapButtons
          .fire({
            title: "Privacy Disclaimer",
            html: `<div
    style='text-align: justify; font-size: 15px; line-height: 20px; margin: 0; border-bottom: 1px solid #595959; padding-bottom: 22px;'>
    You are making a referral containing confidential health/personal information. This transmission (and or attached
    documents) may contain information that is privileged and confidential and should not take place without the
    informed consent of the client.
    Please contact the client/originator prior to sending in the event that explicit consent has not be granted. As
    well, you are hereby notified that,
    any disclosure, dissemination, distribution, copying or other use or action taken without consent is strictly
    prohibited. This e-transmission will be PHIPA compliant. Please note, the C3 vendor in receipt of this documentation
    will only be able to download/access your attachment for 48 hours. Following that time, all documentation will be
    deleted from all C3 servers.<br /><br />
    <b>By clicking proceed with referral,</b> I understand and agree with the above privacy disclaimer and am providing
        consent to share private or confidential information personally or as a representative and/or third party of
        another who has provided consent to share and/or transmit the attached documentation and/or personal health
        information through the C3 referral hub.
    <br /><br />
        <div class="d-flex">
            <input type="checkbox" id="ConsentProvided_id" class="green-checkbox-input">
            <label for="ConsentProvided_id" class="green-checkbox-label cursor-pointer ml-2 mb-0 font-weight-bold">Consent Provided</label>
        </div>
</div>`,
            type: "warning",
            showCancelButton: true,
            confirmButtonText: "Proceed with referral",
            cancelButtonText: "Cancel",
            reverseButtons: true,
            onRender: function () {
              const consentProvided = Swal.getPopup().querySelector(
                "#ConsentProvided_id"
              );
              if (!consentProvided.checked) {
                Swal.getConfirmButton().setAttribute("disabled", "true");
              } else {
                Swal.getConfirmButton().removeAttribute("disabled");
              }
              consentProvided.addEventListener("change", function (event) {
                if (!event.target.checked) {
                  Swal.getConfirmButton().setAttribute("disabled", "true");
                } else {
                  Swal.getConfirmButton().removeAttribute("disabled");
                }
              });
            },
            preConfirm: () => {
              return {
                consentProvided: Swal.getPopup().querySelector(
                  "#ConsentProvided_id"
                ).checked,
              };
            },
          })
          .then((result) => {
            if (result.value) {
              if (!result.value.consentProvided) {
                return;
              }
              vm.$store.dispatch("orders/submitOrder", {
                order: {
                  ...this.order,
                  consentProvided: result.value.consentProvided,
                },
                vendor: this.vendor.id,
              });
            }
          });
      } else {
        this.$store.dispatch("orders/submitOrder", {
          order: this.order,
          vendor: this.vendor.id,
        });
      }
    },
    getServices: function () {
      this.$store.dispatch("services/all");
    },
    uploadAttachment: function (event) {
      let file = event.target.files[0];

      this.$store.dispatch("orders/uploadAttachment", {
        vendor: this.vendor.id,
        user: this.user.id,
        attachmentData: file,
      });
    },
    getFormattedLocation: function (location) {
      return formatLocation(location);
    },
    sortVendorLocations: function (locations) {
      if (this.$route.query.lat) {
        this.sortedlocations = this.getsortedLocations(locations, {
          lat: this.$route.query.lat,
          lng: this.$route.query.lng,
        });
        this.order.location = locations[0].id;
      } else if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            this.sortedlocations = this.getsortedLocations(locations, {
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            });
          },
          (_) => {
            this.sortedlocations = locations;
          },
          {
            enableHighAccuracy: false,
            timeout: 5000,
            maximumAge: Infinity,
          }
        );
      }
      this.sortedlocations = locations;
    },
    getsortedLocations: function (locations, map) {
      // Calculate distances from the map point to each location
      locations.forEach((location) => {
        const distance = this.calculateDistance(
          map.lat,
          map.lng,
          location.lat,
          location.lng
        );
        location.distanceFromMapPoint = distance; // Add a new property to store the distance
      });

      // Sort locations based on their distance from the map point
      locations.sort((a, b) => a.distanceFromMapPoint - b.distanceFromMapPoint);
      return locations;
    },
    // Function to calculate the distance between two points using the Haversine formula
    calculateDistance: function (lat1, lon1, lat2, lon2) {
      const R = 6371; // Earth's radius in kilometers
      const dLat = (lat2 - lat1) * (Math.PI / 180);
      const dLon = (lon2 - lon1) * (Math.PI / 180);
      const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(lat1 * (Math.PI / 180)) *
          Math.cos(lat2 * (Math.PI / 180)) *
          Math.sin(dLon / 2) *
          Math.sin(dLon / 2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      const distance = R * c;

      return distance;
    },
  },
};
</script>

<style scoped lang="scss">
@media (max-width: 767px) {
  .btn-container {
    text-align: center;
  }
}
</style>
